module.exports = __webpack_public_path__ + "static/media/S4N9.d93b313c.svg";